<template>
  <v-flex xs12 sm10 md6 xl4>
    <div class="vertical-center-container">
      <v-select
        label="Select action"
        :items="actions"
        v-model="selectedAction"
        item-value="value"
        return-object
        prepend-inner-icon="list"
        clearable
        :clear-icon-cb="clearAction"
        :color="$store.state.global.pages.allocation.color"
      >
        <template
          slot="selection"
          slot-scope="data"
        >{{ !!selectedCount ? `${data.item.text} for ${selectedCount} batches` : `${data.item.text}`}}</template>
      </v-select>
      <div>
        <v-btn
          :color="$store.state.global.pages[this.$route.name].color"
          flat
          @click="confirmAction()"
        >
          Confirm
          <!-- <v-icon right>save_alt</v-icon> -->
        </v-btn>
      </div>
    </div>

    <!-- EXPORT CSV DIALOG CONFIRMATION -->
    <v-dialog v-model="dialog" max-width="400px" @keydown.esc="dialog = false" lazy>
      <v-card>
        <v-card-title class="headline">
          <span>
            Export selected documents?
            <span class="grey--text subheading"></span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="dialog = false">Cancel</v-btn>
          <download-excel :fetch="allocationBatchLines" type="csv" name="allocationBatch.csv">
            <v-btn
              :color="primaryNeutral"
              flat
              @click="dialog = false"
              :loading="loading"
            >Export Batches</v-btn>
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import AllocationService from "@/services/requests/allocationService";
import BuildBatchQuery from "./mixins/buildBatchQuery";
import DownloadExcel from "vue-json-excel";
import FormatDates from "@/services/mixins/formatDates";
export default {
  mixins: [BuildBatchQuery, FormatDates],
  data() {
    return {
      actions: [
        {
          text: "Export Selected (CSV)",
          icon: "import_export",
          color: "grey",
          value: { value: null, text: "Export Selected (CSV)", label: "export" }
        }
      ],
      selectedAction: {},
      dialog: false,
      loading: false
    };
  },
  methods: {
    clearAction() {
      this.selectedAction = {};
    },
    confirmAction() {
      if (!this.selectedCount) {
        this.snack({ color: "yellow", text: "No batches are selected!" });
        this.dialog = false;
        return;
      }
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: "yellow", text: "No action was selected!" });
        this.dialog = false;
        return;
      } else {
        this.dialog = true;
      }
    },
    async retrieveBatchLines() {
      var payload = this.buildQuery();
      payload.pagination = this.pagination;
      payload.csv = true;
      this.loading = true;
      try {
        var result = await AllocationService.getBatches(payload);
        return result.data.result;
      } catch (err) {
        return [];
      }
    },
    async allocationBatchLines() {
      var lines = await this.getAllocationBatchLines();
      lines = lines.map(line => {
        const driverProject = line.driver.driverProjects.find(({ projectId }) => projectId === line.allocationBatchHeader.site.project.id)
        return {
          Date: line.allocationBatchHeader.date,
          Site: line.allocationBatchHeader.site.name,
          Spoil: line.spoil.name,
          HeaderNotes: line.allocationBatchHeader.notes,
          TimeOfDay: line.allocationBatchHeader.day ? "Day" : "Night",
          StartTime: this.getUTCTime(line.startTime),
          TipName: line.tip.name,
          TipTSE: line.tip.number,
          Vehicle: line.vehicle.name,
          Driver: line.driver.name,
          'Driver Induction Card #': !!driverProject ? driverProject.cardNo : null,
          SubContractor: line.vehicle.contractor.name,
          LineNotes: line.notes
        };
      });
      this.loading = false;
      return lines;
    },
    async getAllocationBatchLines() {
      if (this.selectedAll) {
        return await this.retrieveBatchLines();
      } else {
        //return this.selected
        try {
          var result = await AllocationService.getBatchLinesByBatchIds({
            ids: this.selected.map(batch => batch.id)
          });
          return result.data.result;
        } catch (err) {}
      }
    }
  },
  props: {
    selected: Array,
    selectedCount: Number,
    selectedAll: Boolean,
    pagination: Object
  },
  components: {
    DownloadExcel
  }
};
</script>
